import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { WarningWidget } from "components/Widgets/WarningWidget";
import { ChakraText } from "components/ChakraText";

import { AjaxError } from "HttpService";

import { IChildrenProp } from "types/IChildrenProp";

import { RedirectionButtons } from "../RedirectionButtons";

interface IProps extends IChildrenProp {}

const TokenExpiredErrorBoundary = ({ children }: IProps) => {
  return (
    <ErrorBoundary
      fallback={({ error }) => {
        if (error instanceof AjaxError && error.status === 400) {
          return (
            <>
              <WarningWidget>
                <ChakraText
                  fontSize={{ base: "xl", md: "2xl" }}
                  alignSelf="center"
                >
                  {error.message}
                </ChakraText>
              </WarningWidget>
              <RedirectionButtons />
            </>
          );
        }
        throw error;
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export { TokenExpiredErrorBoundary };
